import { IDeleteProcessoAuditoriaUseCase } from "../../../presentation/useCases/delete/delete_processo_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

// DeleteProcessoAuditoriaUseCase

export class DeleteProcessoAuditoriaUseCase implements IDeleteProcessoAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async deleteProcessoAuditoria(IdProcesso: number, IdAuditoria: number): Promise<void> {
    
    await this.repository.deleteProcessoAuditoria(IdProcesso, IdAuditoria);
  }
}
